import { FC, ReactNode } from 'react';
import { Container, Typography } from '@mui/material';
import { usePhrase } from '@/hooks';
import { JSXFromString } from '@/utils';

interface StaticPageProps {
    headingPhraseId?: number;
    contentPhraseId?: number;
    replaceTextVars?: (string | number)[];
    prependContent?: ReactNode;
}

export const StaticPage: FC<StaticPageProps> = ({
    headingPhraseId,
    contentPhraseId,
    replaceTextVars,
    prependContent,
}) => {
    const { t } = usePhrase();
    return (
        <>
            <Container sx={{ my: 4 }} className="staticPage">
                {headingPhraseId && (
                    <Typography variant="h1" sx={{ mb: 4 }}>
                        {t(headingPhraseId)}
                    </Typography>
                )}
                {prependContent}
                {contentPhraseId && JSXFromString(t(contentPhraseId, { replaceTextVars }))}
            </Container>
        </>
    );
};
